import SalesHeader from '../components/DataTable/StatisticsSalesHeader';
import SoldCell from '../components/DataTable/StatisticsSalesSoldCell';
import DayCell from '../components/DataTable/StatisticsSalesDayCell';
import MultiLineHeader from '../components/DataTable/MultiLineHeader';

const DATA_TITLE = 'data-title';
const rootData = document.getElementById('root').dataset || {};

/**
 * Config for statistics sales table
 */
export default {
    headerComponent: SalesHeader,
    columns: [
        {
            columnName: 'index_col',
            displayName: '',
            headerDataAttrs: {
                [DATA_TITLE]: 'index'
            },
            customCell: {
                component: DayCell,
                options: {
                    columnDate: 'sale_date',
                }
            }
        },
        {
            columnName: 'total_count',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: 'Lots'
                        },
                        {
                            text: 'CATD'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'catd'
            }
        },
        {
            columnName: 'offered_count',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: 'Lots'
                        },
                        {
                            text: 'OFFD'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'offd'
            }
        },
        {
            columnName: 'sold_percent',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: 'Lots'
                        },
                        {
                            text: 'SOLD (%)'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'sold_percent'
            },
            customCell: {
                component: SoldCell,
                options: {
                    columnSold: 'sales_count',
                    columnPercentage: 'sold_percent',
                }
            }
        },
        {
            columnName: 'price_total',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: 'Aggregate'
                        },
                        {
                            text: rootData.currency ? `sales (${rootData.currency})` : 'sales'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'aggregate_sales'
            }
        },
        {
            columnName: 'price_average',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: ` Price${rootData.currency ? ` (${rootData.currency})` : ''}`
                        },
                        {
                            text: 'Average'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'average'
            }
        },
        {
            columnName: 'price_max',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: ` Price${rootData.currency ? ` (${rootData.currency})` : ''}`
                        },
                        {
                            text: 'High'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'high'
            }
        },
        {
            columnName: 'median',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: ` Price${rootData.currency ? ` (${rootData.currency})` : ''}`
                        },
                        {
                            text: 'Median'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'median'
            }
        },
        {
            columnName: 'price_min',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: ` Price${rootData.currency ? ` (${rootData.currency})` : ''}`
                        },
                        {
                            text: 'Low'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'low'
            }
        },
    ]
};



// WEBPACK FOOTER //
// ./src/js/config/statisticsSalesTable.js